import {EditorType, isEditorType} from "./CellContent";
import {isValidKey} from "../utils/functions";
import {ContentKey} from "./Keys";
import {HeadersCommon} from "./HeadersCommon";

const INITIAL_CONTENT_HEADER_NAMES = {
    'perception': '空白',
    'behavior': '行動',
    'action': '施策',
};

const INITIAL_CONTENT_HEADER_SIZE = {
    'perception': 100,
    'behavior': 180,
    'action': 90,
};

export class ContentHeader {
    static readonly __CLASS__ = 'ContentHeader';

    private readonly key: ContentKey;
    private readonly name: string;
    private readonly size: number;
    private readonly is_hidden: boolean;
    private readonly type: EditorType;

    private constructor(key: ContentKey, name: string, size: number, is_hidden: boolean, type: EditorType) {
        this.key = key;
        this.name = name;
        this.size = size;
        this.is_hidden = is_hidden;
        this.type = type;
    }

    get Key() {
        return this.key;
    }

    get Name() {
        return this.name;
    }

    get Size() {
        return this.size;
    }

    get IsHidden() {
        return this.is_hidden;
    }

    get Type() {
        return this.type;
    }

    withName(name: string) {
        return this.clone({name});
    }

    withSize(size: number) {
        return this.clone({size});
    }

    withIsHidden(is_hidden: boolean) {
        return this.clone({is_hidden});
    }

    private clone(replacement: {
        name?: string;
        size?: number;
        is_hidden?: boolean;
    }) {
        return new ContentHeader(
            this.key,
            replacement.name === undefined ? this.name : replacement.name,
            replacement.size === undefined ? this.size : replacement.size,
            replacement.is_hidden === undefined ? this.is_hidden : replacement.is_hidden,
            this.type
        );
    }

    static createDefault(content_key: ContentKey, editor_type: EditorType) {
        const name = INITIAL_CONTENT_HEADER_NAMES[editor_type];
        const size = INITIAL_CONTENT_HEADER_SIZE[editor_type];
        return new ContentHeader(content_key, name, size, false, editor_type);
    }

    static from(origin: ContentHeader) {
        return new ContentHeader(origin.Key, origin.Name, origin.Size, origin.IsHidden, origin.Type);
    }

    static fromJSON(object: any) {
        if (!isEditorType(object.type)) {
            throw new Error("invalid editor_type");
        }
        if (!isValidKey(object.key)) {
            throw new Error("invalid content_key");
        }
        if (typeof object.name !== 'string') {
            throw new Error("invalid name");
        }
        if (typeof object.size !== 'number') {
            throw new Error("invalid size");
        }
        if (typeof object.is_hidden !== 'boolean') {
            throw new Error("invalid is_hidden");
        }

        return new ContentHeader(object.key as ContentKey, object.name, object.size, object.is_hidden, object.type);
    }
}


export class ContentHeaders extends HeadersCommon<ContentHeader> {

    protected cloneHeader(original: ContentHeader): ContentHeader {
        return ContentHeader.from(original)
    }

    get GridTemplateRows() {
        return this.map(c => {
            return (c.IsHidden ? '7' : c.Size) + 'px'
        }).join(' ')
    }

    get HasHidden() {
        return this.any_headers.some(c => c.IsHidden);
    }

    get HiddenKeys() {
        return this.any_headers.filter(f => f.IsHidden).map(f => f.Key);
    }

}
